import React from 'react';
import { DatePicker } from '@roger/ui-components';
import { Question } from '../types';

interface DateQuestionProps {
  question: Question;
  value: Date | string;
  onChange: (value: Date | string) => void;
}

export const DateQuestion: React.FC<DateQuestionProps> = ({
  question,
  value,
  onChange,
}) => {
  // Convert string to Date if needed
  const dateValue =
    value instanceof Date ? value : value ? new Date(value) : undefined;

  const handleDateChange = (date: Date | undefined) => {
    if (date) {
      onChange(date);
    } else {
      onChange('');
    }
  };

  return (
    <div className='space-y-3'>
      <label className='text-sm font-medium text-gray-900 block'>
        {question.description}
        {question.qid && (
          <span className='ml-2 text-xs text-gray-500'>({question.qid})</span>
        )}
      </label>

      <div className='max-w-md'>
        <DatePicker
          date={dateValue}
          onDateChange={handleDateChange}
          placeholder='Select a date...'
        />
      </div>
    </div>
  );
};
